import myFirebase from '../config/config';
import apiCaller from './apiCallerOutstanding';
import logger from './logger';
import { mappedCurrentActiveRole } from './roleMapping';

async function validateTdsMismatch(transactionId, activeRole) {
  const role = mappedCurrentActiveRole(activeRole);
  const endPoint = `trips/validate-tds-mismatch?transaction_id=${transactionId}&role=${role}`;
  const currentUserDetails = myFirebase.auth().currentUser;
  const { Aa: token } = currentUserDetails;
  if (!currentUserDetails) return false;
  try {
    const response = await apiCaller(
      endPoint,
      {},
      `Bearer ${token}`,
      'nh-base',
      'get'
    );
    const data = response?.data?.trips_payable_valid;
    return data || false;
  } catch (e) {
    logger.error('Error', e);
    return false;
  }
}

export default validateTdsMismatch;
